export default __webpack_public_path__ + "static/media/(Low Res) JD Reception-010.86e104a3.jpg";